import type { CSSProperties, ReactNode } from 'react';

const DEFAULT_BORDER_RADIUS = 'rounded-lg';
const DEFAULT_BOX_SHADOW = '0 2px 4px 0 rgba(0, 0, 0, 0.06)';
const DEFAULT_PADDING = '1.6px';

type GradientBorderCardProps = {
  borderRadius?: string;
  boxShadow?: string;
  children: ReactNode;
  className?: string;
  padding?: string;
  style?: CSSProperties;
};

export const GradientBorderCard = ({
  borderRadius = DEFAULT_BORDER_RADIUS,
  boxShadow = DEFAULT_BOX_SHADOW,
  children,
  className = 'gradient-border-spin',
  padding = DEFAULT_PADDING,
  style,
}: GradientBorderCardProps) => {
  return (
    <div
      className={`${borderRadius} ${className}`}
      style={{
        boxShadow,
        padding,
        ...style,
      }}
    >
      <div className={`${borderRadius} overflow-hidden`}>{children}</div>
    </div>
  );
};
